import React from 'react';

interface CircularLoaderProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  fullscreen?: boolean;
}

const CircularLoader: React.FC<CircularLoaderProps> = ({ size = 'medium', className = '', fullscreen = false }) => {
  const sizeStyles = {
    small: { width: '24px', height: '24px', borderWidth: '2px' },
    medium: { width: '40px', height: '40px', borderWidth: '3px' },
    large: { width: '64px', height: '64px', borderWidth: '4px' }
  };

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    minHeight: '200px',
    ...(fullscreen && {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#09090b',
      zIndex: 9999
    })
  };

  const spinnerStyle: React.CSSProperties = {
    ...sizeStyles[size],
    borderColor: '#3f3f46',
    borderTopColor: '#3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  };

  return (
    <div style={containerStyle} className={className}>
      <div style={spinnerStyle}></div>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CircularLoader;